import React from 'react'
import { Currency } from '../../model'
import { PairButton } from './PairButton'
import { PairSelectModal } from './PairSelectModal'
import { usePairSelectModal } from '../../providers'

interface Props {
  currency: Currency
  other: Currency
  onChange: (currency: Currency, other: Currency) => void
}

export function PairSelect({ currency, other, onChange }: Props) {
  const { isPairSelectModalOpen, setPairSelectModalOpen, setPairSelectModalClose } = usePairSelectModal()

  function onSelect(currency: Currency, other: Currency) {
    setPairSelectModalClose()
    onChange(currency, other)
  }

  return (
    <>
      {isPairSelectModalOpen && <PairSelectModal onChange={onSelect} onClose={setPairSelectModalClose} />}
      {currency && <PairButton currency={currency} other={other} onClick={setPairSelectModalOpen} />}
    </>
  )
}
